import * as Api from '@ViewModels';
import { StyleSheet, css } from 'aphrodite';
import * as React from 'react';
import { formatCampaignSendMethod } from '../../../../models/utils/campaignUtils';
import { Button } from '../../../components-v2/Button';
import { THEME } from '../../../components-v2/Theme/theme';
import { baseStyleSheet } from '../../../styles/styles';
import { Tooltip, TooltipContent, TooltipTrigger } from '../../Tooltip';
import { InfoIcon } from '../../svgs/icons/InfoIcon';

const styleSheet = StyleSheet.create({
	sendSpeed: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.xs,
	},
	overlapDisclaimerTrigger: {
		cursor: 'help',
	},
	overlapDisclaimerTooltip: {
		maxWidth: 280,
		whiteSpace: 'normal',
	},
});

const overlapDisclaimerText = 'Other campaigns scheduled in the same window can extend the actual completion time.';

interface ISendSpeedDisplayProps {
	campaign?: Api.ICampaign;
	className?: string;
}

/**
 * Displays the send speed for a campaign (e.g., "As quickly as possible" or "Spread over X days").
 * Returns null if campaign is cancelled or send method cannot be determined.
 */
export const SendSpeedDisplay: React.FC<ISendSpeedDisplayProps> = ({ campaign, className }) => {
	// Check if campaign is cancelled first to avoid unnecessary computation
	if (campaign?.cancelledDate) {
		return null;
	}

	const sendMethodText = formatCampaignSendMethod(campaign);

	if (!sendMethodText) {
		return null;
	}

	return (
		<div className={className}>
			<div className={css(styleSheet.sendSpeed)}>
				<span className={css(baseStyleSheet.fontBold)}>Send Speed:</span>
				<span>{sendMethodText}</span>
				<Tooltip>
					<TooltipTrigger asChild>
						<Button
							aria-label='About send speed timing'
							size='icon'
							styles={[styleSheet.overlapDisclaimerTrigger]}
							type='button'
							variant='ghost'
						>
							<InfoIcon fillColor={THEME.colors.icon.gray} />
						</Button>
					</TooltipTrigger>
					<TooltipContent styles={[styleSheet.overlapDisclaimerTooltip]}>{overlapDisclaimerText}</TooltipContent>
				</Tooltip>
			</div>
		</div>
	);
};
